import { Checkbox, Input } from 'ui'
import { PDField, usePDFStore } from '../../../stores/pdf.store'
import { FieldValidationSignature } from '.'

export const FieldValidationRegex: FieldValidationSignature = ({ field }) => {
  const updateField = usePDFStore((state) => state.updateField)

  return (
    <div>
      <label className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>
        Expresión regular
      </label>
      <Input
        size='sm'
        defaultValue={field.regex || ''}
        onChange={(e) => updateField(field.id, { regex: e.target.value })}
      />
    </div>
  )
}
